import _ from 'lodash';

// names must stay aligned with the delta blots in Builder/Library/Text/Rich/Blots.js
const BLOCKS = {
  'header-two-oswald': { header_two_oswald: true },
  'header-two-roboto': { header_two_roboto: true },
  'header-three-oswald': { header_three_oswald: true },
  'header-three-roboto': { header_three_roboto: true },
  'header-four-roboto': { header_four_roboto: true },
  'header-five-roboto': { header_five_roboto: true },
  'header-six-roboto': { header_six_roboto: true },
  'header-two': { header_two_oswald: true },
  'header-three': { header_three_oswald: true },
  'header-four': { header_four_roboto: true },
  'small-body-copy': { smaller: true },
  disclaimer: { disclaimer: true },
  'unordered-list-item': { list: 'bullet' },
  'ordered-list-item': { list: 'ordered' },
};

const STYLES = {
  BOLD: { bold: true },
  ITALIC: { italic: true },
  UNDERLINE: { underline: true },
  SUPERSCRIPT: { script: 'super' },
  SUBSCRIPT: { script: 'sub' },
  PINK: { pink: true },
};

const EMBEDS = ['document', 'document_builder'];

const attributesPerCharacter = (block, characters, entityMap) => {
  const marks = Array.from({ length: characters.length }, () => ({}));
  const mark = (offset, length, attributes) =>
    marks.slice(Math.max(0, offset), offset + length).forEach(entry => Object.assign(entry, attributes));

  (block.inlineStyleRanges || []).forEach(({ offset, length, style }) => {
    if (STYLES[style]) mark(offset, length, STYLES[style]);
  });
  (block.entityRanges || []).forEach(({ offset, length, key }) => {
    const entity = entityMap?.[key];
    if (entity?.type === 'LINK') mark(offset, length, { link: entity.data?.url });
  });

  return marks;
};

const inlineOps = (block, entityMap) => {
  if (!block.text) return [];

  // draft counts range offsets in code points (fbjs UnicodeUtils.strlen), so an emoji
  // is one position and indexing the raw string by code unit shifts every range after it
  const characters = Array.from(block.text);
  const marks = attributesPerCharacter(block, characters, entityMap);

  return characters.reduce((ops, character, index) => {
    const previous = ops[ops.length - 1];
    if (previous && _.isEqual(marks[index], marks[index - 1])) {
      previous.insert += character;
      return ops;
    }
    const attributes = marks[index];
    return [...ops, _.isEmpty(attributes) ? { insert: character } : { insert: character, attributes }];
  }, []);
};

const blockOps = (block, entityMap) => {
  if (block.type === 'atomic') {
    const { type, props } = block.data || {};
    return EMBEDS.includes(type) && props ? [{ insert: { [type]: props } }] : [];
  }

  const attributes = BLOCKS[block.type] && { ...BLOCKS[block.type] };
  if (attributes?.list && block.depth) attributes.indent = block.depth;

  return [...inlineOps(block, entityMap), attributes ? { insert: '\n', attributes } : { insert: '\n' }];
};

export const isDraftRaw = content => _.isPlainObject(content) && _.isArray(content.blocks);

export default content => ({
  ops: (content.blocks || []).flatMap(block => blockOps(block, content.entityMap)),
});
